import * as React from "react";

import dayjs, { Dayjs } from "dayjs";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";

interface Props {
  value: Dayjs | null;
  onChange: (date: Dayjs | null) => void;
}

export default function DatePickerValue({ value, onChange }: Props) {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DemoContainer components={["DatePicker", "DatePicker"]}>
        <DatePicker
          minDate={dayjs(new Date())}
          label="Uncontrolled picker"
          defaultValue={value}
          onChange={onChange}
        />
      </DemoContainer>
    </LocalizationProvider>
  );
}
